import { MapPin, ExternalLink } from "lucide-react";

export const MANOR_ADDRESS = "1115 Rome St, Petersburg, VA 23803";
export const MANOR_MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(MANOR_ADDRESS)}`;

export function AddressLink({ className = "", iconSize = 14, testId = "address-link", label = MANOR_ADDRESS }) {
  return (
    <a
      href={MANOR_MAPS_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      title="Open in Google Maps for directions"
      className={`group/addr inline-flex items-center gap-1.5 hover:underline decoration-amber-400 underline-offset-4 transition-colors ${className}`}
    >
      <MapPin size={iconSize} className="text-[#F59E0B] shrink-0" />
      <span>{label}</span>
      <ExternalLink size={iconSize - 2} className="opacity-50 group-hover/addr:opacity-100 transition-opacity shrink-0" />
    </a>
  );
}
